import { ReactComponent as BrandSparkle } from "../assets/sparkle.svg";

export function SparkleIcon(props) {
  return (
    <BrandSparkle viewBox="0 0 1254 1254" aria-hidden="true" {...props} />
  );
}
